export interface BatchCollectionMgmtBibColBulkRemovalRequest {
  removalDateFrom: string
  removalDateTo: string
  holdingBranch: string
  removeReason: string

  rdoCollectionType: string
  collectionTypeList: string
  rdoHandlingType: string
  handlingTypeList: string
  rdoShelfType: string
  shelfTypeList: string

  rdoBibColRemovalType: string
  rdoDatabaseUpdate: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtBibColBulkRemovalRequestToJSON(
  value: BatchCollectionMgmtBibColBulkRemovalRequest
): any {
  return {
    removal_date_from: value.removalDateFrom,
    removal_date_to: value.removalDateTo,
    holding_branch: value.holdingBranch,
    remove_reason: value.removeReason,

    rdo_collection_type: value.rdoCollectionType,
    collection_type_list: value.collectionTypeList,
    rdo_handling_type: value.rdoHandlingType,
    handling_type_list: value.handlingTypeList,
    rdo_shelf_type: value.rdoShelfType,
    shelf_type_list: value.shelfTypeList,

    rdo_bib_col_removal_type: value.rdoBibColRemovalType,
    rdo_database_update: value.rdoDatabaseUpdate,
    memo: value.memo,
    batch_type: value.batchType
  }
}
